import type {RootState} from '@/state/store';

export const selectInferenceData = (state: RootState) => state.inference.inferenceData;
export const selectInferenceLoading = (state: RootState) => state.inference.isLoading;
export const selectExperienceScore = (state: RootState) => state.inference.inferenceData?.experienceScore;
export const selectExperienceCalibration = (state: RootState) => state.inference.inferenceData?.calibration;
export const selectExperienceInsightsAndTips = (state: RootState) => state.inference.inferenceData?.insightsAndTips;
export const selectExperienceTipsToConsider = (state: RootState) => state.inference.inferenceData?.tipsToConsider;
export const selectInferenceTimestamp = (state: RootState) => state.inference.inferenceData?.inferenceTimestamp;
export const selectIsCalibrationActive = (state: RootState) => {
    const calibration = state.inference.inferenceData?.calibration;

    if (!calibration) return false;

    return calibration.n_sticks_identified < calibration.min_n_experiences_required;
};
